import { ZONES } from "@/mocks/gua";

export default function Zones() {
  return (
    <section id="zone" className="w-full bg-[#faf6ef]">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-orange-600">分区速览 · 按频道追更</p>
            <h2 className="mt-1.5 text-2xl font-extrabold text-stone-900 md:text-3xl">挑个频道蹲前排</h2>
            <p className="mt-2 text-sm text-stone-500">想看哪块，点进对应频道，每一区的在播热度一目了然。</p>
          </div>
        </div>

        <div className="mt-6 grid gap-3 md:gap-4 lg:grid-cols-2">
          {ZONES.map((z, zi) => (
            <div
              key={z.zone}
              className="flex flex-col rounded-lg border border-stone-200/70 bg-white p-4 md:p-5"
            >
              <div className="flex items-center gap-3 border-b border-dashed border-stone-200 pb-3">
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-lg text-white ${
                    zi % 2 === 0 ? "bg-orange-500" : "bg-rose-500"
                  }`}
                >
                  <i className={zi % 2 === 0 ? "ri-sparkling-2-fill" : "ri-music-2-fill"} />
                </span>
                <div>
                  <h3 className="text-base font-bold text-stone-900">{z.zone}区</h3>
                  <p className="text-[11px] text-stone-400">{z.desc}</p>
                </div>
              </div>

              <ul className="divide-y divide-stone-100">
                {z.items.map((it) => (
                  <li key={it.title}>
                    <a
                      href="#scene"
                      className="group flex items-center gap-3 py-3"
                    >
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-orange-300 transition group-hover:bg-orange-600" />
                      <div className="min-w-0 flex-1">
                        <h4 className="whitespace-nowrap text-sm font-medium text-stone-700 transition group-hover:text-orange-700">
                          {it.title}
                        </h4>
                        <p className="mt-0.5 truncate text-[11px] text-stone-400">{it.summary}</p>
                      </div>
                      <i className="ri-arrow-right-s-line shrink-0 text-stone-300 transition group-hover:translate-x-0.5 group-hover:text-orange-500" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}